import type {DesignModuleSpecJson} from '../data/contracts';

/**
 * QUIZ-NATIVE2 GAP-Q14 (générique, tous modules) : une page peut être déclarée « phase de » une autre page (correction,
 * résultat, confirmation d'un même écran). Une page de phase n'est plus une page du menu ; toute navigation vers elle mène
 * à sa page hôte (alias). Ancien format accepté : sans `phaseOf`, une page reste une page.
 */
type Page={key:string;phaseOf?:string};
type Menu={items?:{page?:string}[]};
type Navigation={menus?:Menu[];homePage?:string};
const pagesOf=(spec:DesignModuleSpecJson)=>(spec.pages??[]) as Page[];

/** Page hôte d'une page de phase (une seule profondeur), sinon la page elle-même. */
export function phaseTarget(pages:readonly Page[],key:string):string{
 const host=pages.find(page=>page.key===key)?.phaseOf;
 return host&&pages.some(page=>page.key===host&&!page.phaseOf)?host:key;
}
/** Pages candidates comme hôte : jamais elle-même ni une page déjà en phase ; une page qui a ses propres phases n'en devient pas une. */
export function phaseHosts(spec:DesignModuleSpecJson,key:string):string[]{
 if(pagesOf(spec).some(page=>page.phaseOf===key))return [];
 return pagesOf(spec).filter(page=>page.key!==key&&!page.phaseOf).map(page=>page.key);
}
/** Déclare (ou retire, host vide) les phases ; elles quittent le menu et l'accueil. Pur : le brouillon d'entrée est intact. */
export function declarePhases(spec:DesignModuleSpecJson,host:string|undefined,phases:string[]):DesignModuleSpecJson{
 const next=structuredClone(spec),pages=pagesOf(next);
 if(host&&(!pages.some(page=>page.key===host&&!page.phaseOf)||phases.includes(host)))throw new Error('studio.command.stale_version');
 for(const key of phases){
  const page=pages.find(item=>item.key===key);if(!page)throw new Error('studio.command.stale_version');
  if(host){if(pages.some(item=>item.phaseOf===key))throw new Error('studio.command.stale_version');page.phaseOf=host;}else delete page.phaseOf;
 }
 if(host){
  const navigation=next.navigation as Navigation|undefined;
  for(const menu of navigation?.menus??[])if(menu.items)menu.items=menu.items.filter(item=>!item.page||!phases.includes(item.page));
  if(navigation?.homePage&&phases.includes(navigation.homePage))navigation.homePage=host;
 }
 return next;
}
